import React, { useState, useEffect, useContext } from "react";
import { FaCoins, FaShoppingCart, FaUser } from "react-icons/fa";
import { MdLogout } from "react-icons/md";
import { Link } from "react-router";
import MainHeader from "../../Components/Header/MainHeader";
import { BASE_URL_API } from "../../References/URLs";
import AuthContext from "../../Store/AuthContext";
import styles from "./Profile.module.css";

const Profile = () => {
    const [user, setUser] = useState(null);
    const [orderHistory, setOrderHistory] = useState([]);
    const [redemptionHistory, setRedemptionHistory] = useState([])
    const authCtx = useContext(AuthContext)

    const [pointsData, setPointsData] = useState({
        "userIdentifier": null,
        "totalCredit": 0,
        "totalDebit": 0,
        "availablePoints": 0
    })


    const getPointsSummary = async () => {
        const getPointsSummaryResponse = await fetch(BASE_URL_API + "getPointsSummary",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: JSON.parse(authCtx.loginData)?.userIdentifier
                })
            });

        if (!getPointsSummaryResponse.ok) {
            console.log("Something went wrong : Server Error!")
        } else {
            const getPointsSummaryRespo = await getPointsSummaryResponse.json()
            if (getPointsSummaryRespo.status === "success") {
                setPointsData(getPointsSummaryRespo.response)
            } else {
                if (getPointsSummaryRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
            console.log(getPointsSummaryRespo)
        }
    }

    const getUserDetails = async () => {
        const getUserDetailsResponse = await fetch(BASE_URL_API + "getUserDetails",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: JSON.parse(authCtx.loginData)?.userIdentifier
                })
            });

        if (!getUserDetailsResponse.ok) {
            console.log("Something went wrong : Server Error!")
        } else {
            const getUserDetailsRespo = await getUserDetailsResponse.json()
            if (getUserDetailsRespo.status === "success") {
                setUser(getUserDetailsRespo.response)
            } else {
                if (getUserDetailsRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                }
            }
            console.log(getUserDetailsRespo)
        }
    }



    useEffect(() => {
        getUserDetails()
        getPointsSummary()
    }, [])



    if (!user) return <div className={styles.loading}>Loading...</div>;

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>


                <div className={styles.profileHeader}>
                    <img
                        src={user.avatar || "https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png"}
                        alt="Profile"
                        className={styles.profileImage}
                    />
                    <div className={styles.userInfo}>
                        <h2>{user?.firstName} {user?.middleName} {user?.lastName}</h2>
                        <p>Email: {user?.workEmail}</p>
                        <p>Phone: {user?.phoneNumber}</p>
                    </div>
                </div>
                <div className={styles.pointsSection}>
                    <div className={styles.availablePoints}>
                        <div className={styles.availablePointsTitle}>Points Balance</div>
                        <div className={styles.points}>{pointsData?.availablePoints} Points</div>
                        <Link to={`/redeem`} >
                            <div className={styles.redeemNowBtn}>
                                Redeem Now
                            </div>
                        </Link>
                    </div>

                    <div>

                    </div>
                </div>
                <div className={styles.profileContainer}>

                </div>
            </div>
        </div>
    );
};

export default Profile;
